export function buildQueryString(params: { [key: string]: unknown }) {
    const searchParams = new URLSearchParams();

    for (const key in params) {
        const value = params[key];

        if (value !== undefined && value !== null) {
            searchParams.set(key, String(value));
        }
    }

    const queryString = searchParams.toString();

    return queryString ? `?${queryString}` : '';
}